export enum FileType {
  png = 0,
  jpg = 1,
  jpeg = 2,
  bmp = 3,
  tiff = 4,
  pdf = 5
}